import { Container, Row, Col, Button, Form, Spinner } from 'react-bootstrap';
import { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../App.css';
import '../../../css/bootstrap.scss';
import email_icon from "../../../images/email_icon.png";
import email_blue_icon from "../../../images/emailBlue.png";
import { useNavigate } from 'react-router-dom';
import Header from '../../Includes/Header';
import Footer from '../../Includes/Footer';
import BackButton from '../../Includes/BackButtonEntityAccount';
import config from '../../../config';
import axios from 'axios';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import renderField from '../../renderField';
import { connect } from 'react-redux';
import { setEmail, setwizardPageNumber, setEmailVerify, setUserID, setKycToken } from '../../EntityAccountReducer';
import { RootState } from '../../store'; // Import the RootState type
import { useDispatch, useSelector } from 'react-redux';
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import { isEmailExist, validateEmail, getUserID } from '../../../Utils/user';
import { resendOtp, verifyOtpAndCreateProfile } from '../../../Utils/otp';
import SuccessOTPModal from '../../Camera/SuccessOTPModal';
import ResendCode from '../../UI/ResendCode';

interface FormData {
    isEmailVerified: boolean;
}

interface Props { };


const VerifyBusinessEmail: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const page = useSelector((state: RootState) => state.entityAccount.wizardPageNumber)
    const email = useSelector((state: RootState) => state.entityAccount.email);
    const userId = useSelector((state: RootState) => state.entityAccount.userID);
    const entityPassword = useSelector((state: RootState) => state.entityAccount.password);
    const [validated, setValidated] = useState(false);
    const [validatedEmpty, setValidatedEmpty] = useState(false);
    const [validatedSuccess, setValidatedSuccess] = useState(false);
    const [showChangeEmail, setShowChangeEmail] = useState(false);
    const [newEmail, setNewEmail] = useState('');
    const [emailChangeLoading, setEmailChangeLoading] = useState(false);
    const [emailChangeError, setEmailChangeError] = useState('');
    const registermini_baseURL = config.NODE_API_BASE_URL + '/wso2/registermini';

    const [loading, setLoading] = useState(false);

    const [showMessage, setShowMessage] = useState(true); // State to manage the visibility of the message

    const handleOkClick = () => {
        setShowMessage(false); // Set showMessage state to false when the button is clicked
    };

    const [timer, setTimer] = useState(30);
    const [resendEnabled, setResendEnabled] = useState(false);
    const [maxResendsReached, setMaxResendsReached] = useState(false);
    const [verifyErrorCode, setVerifyErrorCode] = useState<string | null>(null);


    useEffect(() => {
        let interval: any;

        if (timer > 0 && !resendEnabled) {
            interval = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        } else if (timer === 0 && !resendEnabled) {
            // Enable the link after the timer reaches 0
            setResendEnabled(true);
        }

        return () => clearInterval(interval);
    }, [timer, resendEnabled]);

    var num1: any = useRef(null)
    var num2: any = useRef(null)
    var num3: any = useRef(null)
    var num4: any = useRef(null)
    var num5: any = useRef(null)
    var num6: any = useRef(null)

    // const getUserID = async (email: string) => {

    //     try {

    //         const getUserIDRespnse = await axios.post(config.NODE_API_BASE_URL + '/wso2/getUserID', {
    //             email: email


    //         }).catch((reason: AxiosError<{ additionalInfo: string }>) => {
    //             if (reason.response!.status != 200) {
    //                 notifyError("User ID not found");

    //             }
    //             console.log(reason.message)
    //         })
    //         // console.log("getUserIDRespnse" ,getUserIDRespnse);
    //         if (getUserIDRespnse?.data?.userId) {
    //             return getUserIDRespnse.data.userId;
    //         } else {

    //             return 0;
    //         }


    //     } catch (error: any) {
    //         console.error(error);

    //     }


    // }

    const verifyOtp = async (userEnteredOtp: string, userId: string) => {

        try {
            const data = await verifyOtpAndCreateProfile({ userId, userEnteredOtp });
            if (data?.status === 1) {
                setValidated(false);
                setVerifyErrorCode(null);
            } else {
                setValidated(true);
                setVerifyErrorCode(data?.code ?? null);
                fieldsEmpty();
            }
            return data;
        } catch (error: any) {
            console.error(error);
            setValidated(true);
            fieldsEmpty();
        }

    }

    const resendCode = async () => {

        try {
            setValidated(false);
            setValidatedEmpty(false);
            setValidatedSuccess(false);
            // Disable the link
            setResendEnabled(false);
            const data = await resendOtp(email);
            if (data?.status === 1) {
                setValidatedSuccess(true);
                const nextResendSeconds = data.nextResendAt
                    ? Math.max(Math.ceil((new Date(data.nextResendAt).getTime() - Date.now()) / 1000), 1)
                    : 30;
                setTimer(nextResendSeconds);
            } else if (data?.code === 'MAX_RESENDS_REACHED') {
                setMaxResendsReached(true);
                notifyError(data.msg || 'Maximum resend attempts reached.');
            } else if (data?.code === 'TOO_SOON' || data?.code === 'LOCKED') {
                setTimer(data.retryAfterSeconds || 30);
                notifyError(data.msg || 'Please wait before requesting another code.');
            } else {
                notifyError('Something Went Wrong');
                setResendEnabled(true);
                fieldsEmpty();
            }
        } catch (error: any) {
            console.error(error);
            notifyError('Something Went Wrong');
            setResendEnabled(true);
            fieldsEmpty();
        }

    }

    const submitForm = async (formValues: FormData) => {
        const userEnteredOtp = `${num1.current?.value}${num2.current?.value || ''}${num3.current?.value || ''}${num4.current?.value || ''}${num5.current?.value || ''}${num6.current?.value || ''}`;


        if (userEnteredOtp == '') {
            setValidatedEmpty(true);
            return;
        }

        const userId = await getUserID(email);
        const Response = await verifyOtp(userEnteredOtp, userId);

        if (Response?.status && Response.status == 1) {
            const kycToken = Response.profile?.kyc_token;
            if (kycToken) {
                dispatch(setKycToken(kycToken));
            }
            dispatch(setEmailVerify(true));
            handleShowModal1();
            //Direct user to the Kyc Page
            dispatch(setwizardPageNumber(1));
            navigate(`/kyc/entity/${encodeURIComponent(userId)}/${encodeURIComponent(kycToken || '')}`);
        }

    };


    const handleOtpInput = (e: React.ChangeEvent<HTMLInputElement>, nextInputRef: React.RefObject<HTMLInputElement> | null) => {
        const input = e.target;
        const value = input.value;
        setValidatedEmpty(false);
        setValidatedSuccess(false);
        setValidated(false);

        // Ensure that the input value is a single digit
        if (value.length === 1 && /^\d$/.test(value)) {
            // Move focus to the next input field if available
            if (nextInputRef && nextInputRef.current) {
                nextInputRef.current.focus();
            }
        } else {
            input.value = '';
        }
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        // Extract the pasted content
        const pastedText = e.clipboardData.getData('text');

        // If the pasted text is a valid OTP (e.g., numeric and of the correct length), distribute it to the input fields
        if (/^\d+$/.test(pastedText) && pastedText.length === 6) {
            const otpArray = pastedText.split('');

            // Assign each value to the corresponding input field
            [num1, num2, num3, num4, num5, num6].forEach((ref, index) => {
                if (ref.current) {
                    ref.current.value = otpArray[index];
                }
            });

            // Set the focus on the last input field
            if (num6.current) {
                num6.current.focus();
            }

            // Optionally, trigger the handleOtpInput logic for the last input to move focus
            if (num6.current) {
                handleOtpInput({ target: { value: otpArray[5] } } as React.ChangeEvent<HTMLInputElement>, null);
            }

            // Prevent the default paste behavior
            e.preventDefault();
        }
    };


    const handleBackspace = (currentRef: React.RefObject<HTMLInputElement>, prevRef: React.RefObject<HTMLInputElement> | null) => {
        console.log('Backspace pressed');
        if (currentRef && currentRef.current) {
            // Check if the input value is already empty
            if (currentRef.current.value === '') {
                // If the input is empty, move focus to the previous input and clear its value
                console.log('Clearing previous input');
                if (prevRef && prevRef.current) {
                    prevRef.current.focus();
                }
                // Optionally, clear the value of the previous input
                if (prevRef && prevRef.current) {
                    prevRef.current.value = '';
                }
            } else {
                // If the input is not empty, simply clear its value
                currentRef.current.value = '';
            }
        }
    };

    const fieldsEmpty = () => {
        num1.current.value = "";
        num2.current.value = "";
        num3.current.value = "";
        num4.current.value = "";
        num5.current.value = "";
        num6.current.value = "";
    }

    const handleEmailUpdate = async () => {
        const trimmed = newEmail.trim();
        if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
            setEmailChangeError('Please enter a valid email address.');
            return;
        }
        setEmailChangeLoading(true);
        setEmailChangeError('');
        try {
            const response = await axios.post(registermini_baseURL, {
                email: trimmed,
                password: entityPassword,
                account_type: 'entity',
            });
            dispatch(setEmail(trimmed));
            dispatch(setUserID(response.data.userId));
            setNewEmail('');
            setShowChangeEmail(false);
            fieldsEmpty();
            setValidated(false);
            setVerifyErrorCode(null);
            setMaxResendsReached(false);
            setTimer(30);
            setResendEnabled(false);
        } catch (error: any) {
            setEmailChangeError(
                error?.response?.data?.message || 'Failed to update email. Please try again.'
            );
        } finally {
            setEmailChangeLoading(false);
        }
    };

    const [showModal1, setShowModal1] = useState(false);


    const handleShowModal1 = () => {
        setShowModal1(true);
    };
    const handleCloseModal1 = async () => {
        setShowModal1(false);

    };

    return (
        <>
            <SuccessOTPModal
                show={showModal1}
                handleClose={handleCloseModal1}
                title='Verification Completed'
            />
            <ToastBox />
            <Container fluid className="flex-grow-1 d-flex flex-column align-items-center justify-content-center py-4">
                <div className="text-center" style={{ maxWidth: 480, width: "100%" }}>
                    <img src={email_icon} width={50} />
                    <h3 className='text-center mt-3'>{t('register.verify_email_title')}</h3>
                    <span className='fw-normal'>{t('register.code_sent')} <br /><span className='fw-bold'>{email}</span>. {t('register.code_valid')}</span>
                    <br />
                    <span
                        className='text-primary'
                        style={{ cursor: 'pointer' }}
                        onClick={() => { setShowChangeEmail((p) => !p); setEmailChangeError(''); }}
                    >
                        {t('register.change_email')}
                    </span>

                    {showChangeEmail && (
                        <div className="mt-3 d-flex justify-content-center align-items-center flex-wrap gap-2">
                            <input
                                type="email"
                                className="form-control rounded-5 py-1"
                                style={{ maxWidth: 260 }}
                                placeholder="Enter new email address"
                                value={newEmail}
                                onChange={(e) => { setNewEmail(e.target.value); setEmailChangeError(''); }}
                                onKeyDown={(e) => e.key === 'Enter' && handleEmailUpdate()}
                            />
                            <Button
                                variant="primary"
                                size="sm"
                                className="rounded-5 px-3"
                                onClick={handleEmailUpdate}
                                disabled={emailChangeLoading}
                            >
                                {emailChangeLoading
                                    ? <Spinner as="span" size="sm" animation="border" />
                                    : 'Send OTP'}
                            </Button>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                className="rounded-5 px-3"
                                onClick={() => { setShowChangeEmail(false); setNewEmail(''); setEmailChangeError(''); }}
                            >
                                Cancel
                            </Button>
                            {emailChangeError && (
                                <p className="text-danger small w-100 text-center mb-0">{emailChangeError}</p>
                            )}
                        </div>
                    )}
                    <p className='mt-3 letter-spacing-fix fw-medium mb-2'>{t('kyc.confirm_secure')}</p>

                    <Form noValidate={true} onSubmit={handleSubmit(submitForm)}>
                        <div className="input-group d-flex justify-content-center">
                            <div className="input-group d-flex justify-content-center">
                                <input
                                    type="number"
                                    onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num2)}
                                    ref={num1}
                                    className='rounded-4 border border-1 otp-input'
                                    onPaste={handlePaste}
                                    onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num1, null)}
                                />
                                <input
                                    type="number"
                                    onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num3)}
                                    ref={num2}
                                    className='ms-2 rounded-4 border border-1 otp-input'
                                    maxLength={1}
                                    onPaste={handlePaste}
                                    onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num2, num1)}
                                />
                                <input
                                    type="number"
                                    onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num4)}
                                    ref={num3}
                                    className='ms-2 rounded-4 border border-1 otp-input'
                                    maxLength={1}
                                    onPaste={handlePaste}
                                    onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num3, num2)}
                                />
                                <input
                                    type="number"
                                    onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num5)}
                                    ref={num4}
                                    className='ms-2 rounded-4 border border-1 otp-input'
                                    maxLength={1}
                                    onPaste={handlePaste}
                                    onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num4, num3)}
                                />
                                <input
                                    type="number"
                                    onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num6)}
                                    ref={num5}
                                    className='ms-2 rounded-4 border border-1 otp-input'
                                    maxLength={1}
                                    onPaste={handlePaste}
                                    onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num5, num4)}
                                />
                                <input
                                    type="number"
                                    onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, null)}
                                    ref={num6}
                                    className='ms-2 rounded-4 border border-1 otp-input'
                                    maxLength={1}
                                    onPaste={handlePaste}
                                    onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(num6, num5)}
                                />
                            </div>

                            {validated && (
                                <p className='text-danger fw-bold small text-start mt-2 mb-0'>
                                    {verifyErrorCode === 'OTP_EXPIRED'
                                        ? t('common.otp_expired', 'This code has expired. Please resend.')
                                        : verifyErrorCode === 'LOCKED'
                                        ? t('common.otp_locked', 'Too many attempts. Please try again later.')
                                        : t('common.otp_invalid')}
                                </p>
                            )}
                            {validatedEmpty && <p className='text-danger fw-bold small text-start mt-2 mb-0'>{t('common.otp_enter_valid')}</p>}
                            {validatedSuccess && <p className='text-success fw-bold small text-start mt-2 mb-0'>{t('common.otp_sent')}</p>}

                        </div>
                        <div className='d-grid gap-2 col-md-8 mx-auto mt-4'>
                            <Button type="submit" className='btn btn-primary mt-3 rounded-5'>
                                {t('common.submit')}
                            </Button>
                        </div>
                    </Form>
                    <ResendCode timer={timer} resendEnabled={resendEnabled} resendCode={resendCode} maxResendsReached={maxResendsReached} />
                </div>
                {/* {showMessage && (
                    <div className="d-flex justify-content-center align-items-center mt-3">
                        <Row className='col-md-4 p-3'>
                            <Col md={1} className='text-end mt-2'>
                                <img src={email_blue_icon} width={45} />
                            </Col>
                            <Col md={11} className='text-start mt-2'>
                                <span className='ms-3 fw-bold'>Code sent to your email</span>
                                <p className='fw-normal text-secondary ms-3 small'>If you have not received the code, you can try to:</p>
                            </Col>

                            <span className='text-secondary small'>1. Check if it is in your junk/spam mail.</span>
                            <span className='text-secondary small'>2. Make sure your email address is samran_habib@gmail.com</span>
                            <span className='text-secondary small'>3. The message may be delayed for a few minutes. Try again after 20 minutes.</span>
                            <div className='d-grid gap-2 col-md-7 mx-auto mt-2'>
                                <Button onClick={handleOkClick} className='btn btn-primary border-0 text-white  rounded-5' style={{ background: '#0B1628' }}>
                                    Ok, I understand
                                </Button>
                            </div>
                        </Row>
                    </div>
                )} */}
            </Container>

        </>
    );
}


const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'entityWizard',
    enableReinitialize: true,

})(VerifyBusinessEmail);

export default connect(null)(form);